<mat-dialog-content>
  <div
    *ngIf="isLoading"
    class="d-flex flex-col flex-wrap align-items-center justify-content-center"
    style="padding-bottom: 36px"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>Cargando Platos...</p>
  </div>

  <div
    *ngIf="!isLoading"
    style="display: flex; justify-content: space-between; margin-bottom: 1rem"
  >
    <div style="width: 30rem">
      <form style="align-content: center">
        <mat-form-field appearance="outline" style="width: 30rem">
          <mat-label>Plato</mat-label>
          <input
            type="text"
            placeholder="Elige un plato"
            matInput
            required
            [formControl]="myControl"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="getOptionText"
          >
            <mat-option
              *ngFor="let option of filteredOptions$ | async"
              [value]="option"
            >
              {{ option.nombrePlato }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </div>

    <div style="display: flex; align-items: center">
      <button mat-mini-fab (click)="addDishSelection()">
        <mat-icon style="color: white">add</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="addedDishes.length > 0" class="table-responsive">
    <mat-table [dataSource]="dataSource">
      <ng-conta6iner matColumnDef="nombre">
        <mat-header-cell *matHeaderCellDef> Nombre </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.nombrePlato }}
        </mat-cell>
      </ng-conta6iner>

      <ng-container matColumnDef="categoria">
        <mat-header-cell *matHeaderCellDef> Categoría </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.categoria }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="observaciones">
        <mat-header-cell *matHeaderCellDef> Observaciones </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.observaciones }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <mat-dialog-actions *ngIf="!isLoading" align="center">
    <button mat-raised-button mat-dialog-close>Cancelar</button>
    <button mat-raised-button color="primary" (click)="addPlatostoMenu()">
      Guardar Platos
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
